import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { TreatmentProvider, TreatmentProviderSearchQuery, _211ProviderSearchQuery } from '../treatment-locator/models/TreatmentProviders.models';
import { SupportAndHealthServices } from '../treatment-locator/components/support-and-health-services-list-item/support-and-health-services-list-item.component';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(
    private http: HttpClient
  ) { }

  searchTreatmentProviders(searchFilters: TreatmentProviderSearchQuery) {
    return this.http.post<TreatmentProvider[]>(`${environment.apiUrl}/search`, searchFilters);
  }
  searchSupportAndHealthServices(searchFilters: TreatmentProviderSearchQuery) {
    return this.http.post<SupportAndHealthServices[]>(`${environment.apiUrl}/search`, searchFilters);
  }
  search211Providers(searchFilters: _211ProviderSearchQuery) {
    return this.http.post<TreatmentProvider[]>(`${environment.apiUrl}/search/211`, searchFilters);
  }
}
